var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 20H17.1377V12.9692C17.1377 11.1289 16.3771 9.87257 14.7046 9.87257C13.4253 9.87257 12.7139 10.7204 12.3828 11.5374C12.2586 11.8307 12.278 12.2392 12.278 12.6478V20H7.46097C7.46097 20 7.52306 7.54563 7.46097 6.41353H12.278V8.54582C12.5626 7.6135 14.1018 6.2829 16.5582 6.2829C19.6057 6.2829 22 8.23718 22 12.4454V20ZM2.5896 4.7141H2.55856C1.00635 4.7141 0 3.67548 0 2.35896C0 1.01684 1.0361 0 2.61935 0C4.20132 0 5.17403 1.01429 5.20508 2.35513C5.20508 3.67165 4.20131 4.7141 2.5896 4.7141ZM0.554901 6.41353H4.8429V20H0.554901V6.41353Z",
    fill: "#007EBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.874e24cb1d36c8cfcd689eb70cf3e0a7.svg";
export { ForwardRef as ReactComponent };